import { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import MainMenu from "./MainMenu";
import Submenus from "./Submenus";
import { Link, useNavigate } from "react-router-dom";
import API_URL from "../../config.js";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
import { useCart } from "../contextApi/cartContext.js";
import LanguageDropdown from "../utility/LanguageDropdown.jsx";
import { FiCreditCard, FiLogOut, FiShoppingCart, FiUser } from "react-icons/fi";
import { useUser } from "../contextApi/userContext.js";

const Navbar = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [subMenuItems, setSubMenuItems] = useState([]);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const navigate = useNavigate();
  const { cartItems } = useCart();
  const { logout, isLoggedIn } = useUser();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    axios
      .get(`${API_URL}/layout/header`)
      .then((response) => {
        setMenuItems(response.data?.Menu || []);
        setSubMenuItems(response?.data?.Submenu || []);
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleServicesClick = () => {
    setShowSubMenu(!showSubMenu);
  };

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleUserDropdown = () => {
    setShowUserDropdown(!showUserDropdown);
  };

  const handleUserOptionClick = (option) => {
    setShowUserDropdown(false);
    setIsMobileMenuOpen(false);
    // Handle different user options here
    switch (option) {
      case "profile":
        navigate("/profile");
        break;
      case "wallet":
        navigate("/wallet");
        break;
      case "cart":
        navigate("/cart");
        break;
      case "login":
        navigate("/claim-rewards");
        break;
      case "logout":
        logout();
        break;
      default:
        break;
    }
  };

  return (
    <header className="bg-white shadow-sm sticky-top">
      <Header />
      <nav className="">
        <div className="container d-flex align-items-center justify-content-between">
          {isMobile && <LanguageDropdown />}

          <Link className="navbar-brand" to="/">
            <img
              src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/New-Logo-Elite-Body-Home-01.png"
              alt="Logo"
              className="img-fluid"
              style={{ width: "185px", height: "70px" }}
            />
          </Link>
          <div className="d-flex align-items-center">
            {isMobile && (
              <>
                {/* <div
                  className="position-relative me-3"
                  onClick={toggleUserDropdown}
                  style={{ cursor: "pointer" }}
                >
                  <FiUser
                    className="fs-3 text-dark"
                    onClick={
                      isLoggedIn
                        ? toggleUserDropdown
                        : () => handleUserOptionClick("login")
                    }
                  />

                
                  {!isLoggedIn && (
                    <div className="position-absolute start-50 translate-x-n50 mt-1 animate-bounce">
                      <div
                        className="triangle-up mx-auto"
                        style={{
                          width: 0,
                          height: 0,
                          borderLeft: "5px solid transparent",
                          borderRight: "5px solid transparent",
                          borderBottom: "5px solid #1a1a1a",
                        }}
                      ></div>
                      <div className="bg-dark text-white px-2 py-1 rounded text-xs nowrap">
                        Login
                      </div>
                    </div>
                  )}

                 
                  {isLoggedIn && (
                    <div
                      className={`position-absolute end-0 mt-2 py-2 bg-white rounded shadow border border-light animated-dropdown ${
                        showUserDropdown ? "show" : ""
                      }`}
                      style={{ width: "220px", zIndex: 1100 }}
                    >
                      <div
                        className="dropdown-item px-4 pb-2 pt-3 d-flex align-items-center hover-bg-light"
                        onClick={() => handleUserOptionClick("profile")}
                      >
                        <FiUser className="me-3" size={20} />
                        <span className="fw-medium">Booked Service</span>
                      </div>
                      <div
                        className="dropdown-item px-4 py-2 d-flex align-items-center hover-bg-light"
                        onClick={() => handleUserOptionClick("wallet")}
                      >
                        <FiCreditCard className="me-3" size={20} />
                        <span className="fw-medium">Wallet</span>
                      </div>
                      <div
                        className="dropdown-item px-4 py-2 d-flex align-items-center hover-bg-light"
                        onClick={() => handleUserOptionClick("cart")}
                      >
                        <FiShoppingCart className="me-3" size={20} />
                        <span className="fw-medium">Cart</span>
                        {cartItems.length > 0 && (
                          <span
                            className="ms-auto text-white text-xs fw-bold px-2 py-1 rounded-pill"
                            style={{
                              backgroundColor: "#c69933",
                            }}
                          >
                            {cartItems.length}
                          </span>
                        )}
                      </div>
                      <div className="border-top my-1"></div>

                      <div
                        className="dropdown-item px-4 py-3 d-flex align-items-center text-danger hover-bg-light"
                        onClick={() => handleUserOptionClick("logout")}
                      >
                        <FiLogOut className="me-3" size={20} />
                        <span className="fw-medium">Logout</span>
                      </div>
                    </div>
                  )}
                </div> */}

                <button
                  className="navbar-toggler border-0 bg-transparent"
                  type="button"
                  onClick={toggleMobileMenu}
                  aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
                >
                  {isMobileMenuOpen ? (
                    <FaTimes className="fs-1" aria-hidden="true" />
                  ) : (
                    <GiHamburgerMenu className="fs-1" aria-hidden="true" />
                  )}
                </button>
              </>
            )}
          </div>

          {/* Desktop Menu */}
          {!isMobile && (
            <div className="d-flex align-items-center">
              <MainMenu
                menuItems={menuItems}
                onServicesClick={handleServicesClick}
                subMenuItems={subMenuItems}
              />
            </div>
          )}
        </div>
      </nav>

      {/* Desktop Submenu */}
      {showSubMenu && !isMobile && (
        <div
          className="container-fluid shadow-md"
          style={{
            backgroundColor: "#f0f0f0",
          }}
        >
          <Submenus subMenuItems={subMenuItems} />
        </div>
      )}

      {/* Mobile Menu Drawer */}
      {isMobile && (
        <div
          className={`mobile-menu-drawer ${isMobileMenuOpen ? "open" : ""}`}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "white",
            zIndex: 1000,
            transform: isMobileMenuOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
            overflowY: "auto",
            marginTop: "70px",
          }}
        >
          <MainMenu
            menuItems={menuItems}
            onServicesClick={handleServicesClick}
            subMenuItems={subMenuItems}
            toggleMobileMenu={toggleMobileMenu}
            isMobile={isMobile}
          />
        </div>
      )}
    </header>
  );
};

export default Navbar;
